import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies, { expires: '60MIN', path: '/', domain: process.env.NODE_ENV === 'production' ? 'dth-ewht.com' : '', secure: process.env.NODE_ENV === 'production' ? true : '', sameSite: 'Lax' })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
